import Tile from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS'
import OSM from 'ol/source/OSM'
var LayerParserBlis = function () {

}
LayerParserBlis.prototype.parse = function (jsonIn) {
    var layers = [];
    jsonIn
        .forEach(function (layer) {
            switch (layer.owsServiceType) {
            case "WMS":
                var ollayer = new Tile({
                    baseLayer: layer.options.isBaseLayer,
                    visible: layer.options.visibility,
                    name: layer.name,
                    title:layer.options.displayName_de,
                    source: new TileWMS({
                        url: layer.url,
                        attributions: layer.attribution,
                        params: {
                            'LAYERS': layer.params.layers,
                            'TILED': true
                        },
                        serverType: 'geoserver',
                        // Countries have transparency, so do not fade tiles:
                        transition: 0
                    })
                })
                if (layer.name == "Luftbilder NRW") {
                    ollayer
                        .set(
                            "preview",
                            "https://www.wmts.nrw.de/geobasis/wmts_nw_dop/tiles/nw_dop/EPSG_25832_16/11/641/979.jpeg")
                }
                layers.push(ollayer)
                break;
            case "OSM":

                layers.push(new Tile({
                    baseLayer: true,
                    visible: layer.options.visibility,
                    name: layer.name,
                    title:layer.options.displayName_de,
                    source: new OSM()
                }))
                break;
            }

        });
    return layers;
}
export default LayerParserBlis